import React from 'react';
import { IDENTIFIANT_KEYS, identifiantHref, identifiantsOf, isIdentifiantOn } from '../../utils/clientIdentifiants';

const ClientIdentifiantsPills = ({ row, onOpen }) => {
  const ids = identifiantsOf(row);
  const disappeared = Boolean(row.disappeared_from_dolibarr);

  return (
    <div className="client-identifiants-pills">
      {IDENTIFIANT_KEYS.map((item) => {
        const on = item.key === 'dolibarr' ? !disappeared && isIdentifiantOn(ids, item.key) : isIdentifiantOn(ids, item.key);
        const href = on ? identifiantHref(ids, item.key) : '';
        const className = [
          'client-identifiant-pill',
          on ? 'client-identifiant-pill--on' : 'client-identifiant-pill--off',
          ids.a_verifier && !on ? 'client-identifiant-pill--pending' : '',
        ].filter(Boolean).join(' ');

        if (href) {
          return (
            <a
              key={item.key}
              className={className}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              title={`Ouvrir ${item.label}`}
              aria-label={`Ouvrir ${item.label}`}
              onClick={(event) => event.stopPropagation()}
            >
              {item.letter}
            </a>
          );
        }

        return (
          <button
            key={item.key}
            type="button"
            className={className}
            title={on ? item.label : `${item.label} — non rattaché`}
            aria-label={item.label}
            onClick={(event) => {
              event.stopPropagation();
              onOpen?.(item.key);
            }}
          >
            {item.letter}
          </button>
        );
      })}
    </div>
  );
};

export default ClientIdentifiantsPills;
